import { LayoutService } from './layout/layout.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppInitService } from './services/app-init.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import * as g from 'src/app/globals';
import { Router } from '@angular/router';
import { NotifyService } from './services/notify.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  initializeScripts = new EventEmitter();
  constructor(
    private http: HttpClient,
    private messageService: NzMessageService,
    private layoutService: LayoutService,
    private router: Router,
    private notifyService: NotifyService,
  ) {}

  isTokenValid(appKey?: string) {
    let authMethod;
    if (appKey != null && appKey !== undefined && appKey !== '') {
      authMethod = this.http
        .get(`${g.apiBaseUrl}Authenticate/CheckToken`)
        .toPromise();
    } else {
      authMethod = this.http
        .get(`${g.apiBaseUrl}Authenticate/CheckToken`)
        .toPromise();
    }
    return authMethod;
  }

  externalLogin(email: string, password: string, t: string, fat: string) {
    return this.http.post(`${g.apiBaseUrl}ExternalAccount/GetCustomerCompany`, {
      email,
      password,
      returnCompaniesWhenOne: true,
      t,
      fat,
    });
  }

  externalLoginToCompany(
    email: string,
    password: string,
    contactId: number,
    company: string,
    t: string,
    fat: string,
  ) {
    return this.http.post(`${g.apiBaseUrl}ExternalAccount/ContactLogOn`, {
      email,
      password,
      contactId,
      company,
      token: true,
      t,
      fat,
    });
  }

  isTokenValidAsync() {
    return this.http.get(`${g.apiBaseUrl}Authenticate/CheckToken`);
  }

  logout(switchToCompany?: string) {
    this.notifyService.stopTimeOut.emit();

    let newHeaders = new HttpHeaders();
    newHeaders = newHeaders
      .append('Authorization', 'Bearer ' + g.getToken())
      .append('Language', g.language)
      .append('App', g.app);
    if (!newHeaders.has('Content-Type')) {
      newHeaders = newHeaders.append('Content-Type', 'application/json');
    }

    const token = g.getToken();
    if (switchToCompany === undefined || switchToCompany === '') {
      if (!g.tokenInCookie) {
        localStorage.removeItem('token');
      } else {
        document.cookie =
          'token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
      }
    }

    if (switchToCompany === undefined) {
      switchToCompany = '';
    }

    return this.http.get(
      `${g.apiBaseUrl}authenticate/logout?switchToCompany=${switchToCompany}`,
      {
        headers: newHeaders,
      },
    );
  }

  getIdentityDetails() {
    return this.http.get(`${g.apiBaseUrl}layout/IdentityDetails`);
  }

  afterLogin(
    token: string,
    navigateAfter: boolean,
    document: Document,
    submitCompleted: EventEmitter<boolean>,
    appInitService: AppInitService,
    external: boolean = false,
    navigationAfterLogin = false,
    navigationData: { moduleId; recordId } = null,
    returnUrl: string = '',
  ) {
    console.log('afterLogin execution will be started', token);
    if (!g.tokenInCookie) {
      localStorage.setItem('token', token);
    } else {
      document.cookie = `token=${token}; path=/; Secure; SameSite=Strict`;
    }
    console.log('appInitService.init will be executed', appInitService);
    appInitService.init(false).then(() => {
      console.log('appInitService.init will be started', token);
      this.messageService.create(
        'success',
        this.layoutService.translate('Authentication success.'),
      );
      if (submitCompleted !== null) {
        submitCompleted.emit(true);
      }

      const existingScripts =
        document.getElementsByClassName('data-bweb-script');
      for (let i = 0; i < existingScripts.length; i++) {
        existingScripts.item(i).remove();
      }

      this.layoutService.getScripts().subscribe((scripts: number[]) => {
        scripts.forEach((script) => {
          const scriptEle = document.createElement('script');
          scriptEle.id = 'script-' + script;
          scriptEle.type = 'text/javascript';
          scriptEle.className = 'data-bweb-script';
          scriptEle.src = `${
            g.apiBaseUrl
          }Layout/ScriptJs?id=${script}&${g.getUrlSuffix()}`;

          document.getElementsByTagName('body').item(0).appendChild(scriptEle);
        });
      });

      console.log('here');
      this.layoutService.getStyles().subscribe((styles: number[]) => {
        styles.forEach((style) => {
          const styleEle = document.createElement('link');
          styleEle.id = 'style-' + style;
          styleEle.rel = 'stylesheet';
          styleEle.type = 'text/css';
          styleEle.className = 'data-bweb-style';
          styleEle.href = `${g.apiBaseUrl}Miscellaneous/StyleJs?id=${style}`;
          //}Layout/StyleJs?id=${style}`;

          document.getElementsByTagName('head').item(0).appendChild(styleEle);
        });
      });

      if (returnUrl != null && returnUrl !== undefined && returnUrl !== '') {
        this.router.navigate([returnUrl]);
        return;
      }

      console.log('navigateAfter', navigateAfter);

      /*if (!external) {
        this.notifyService.start();
      }*/
      if (navigateAfter) {
        if (external && !navigationAfterLogin) {
          this.router.navigate(['/apps/external-portal/index']);
        } else if (navigationAfterLogin) {
          this.router.navigate([
            `/apps/external-portal/app-container/10/module-list/${navigationData.moduleId}/0`,
            { selectedId: navigationData.recordId },
          ]);
        } else {
          this.router.navigate(['/apps']);
        }
      } else {
        if (external && !navigationAfterLogin) {
          this.router.navigate(['/apps/external-portal/index']);
        } else if (navigationAfterLogin) {
          this.router.navigate([
            `/apps/external-portal/app-container/10/module-list/${navigationData.moduleId}/0`,
            { selectedId: navigationData.recordId },
          ]);
        } else {
          this.router.navigate(['/apps']);
        }
      }
    });
  }
}
